module.exports = __webpack_public_path__ + "img/newsIndImg7.cf8ce577.png";